<template lang="pug">
.page
  .row
    h1.col-12.text-center My Sprites
  .row.filters
    input.search.float-left(placeholder="Search", v-model='search')
  .row
    .col-12.col-md-3(v-for='(sprite, index) in emptySprites', @click='viewSprite(userSprites[index])')
      my-sprite-item(:sprite='filteredSprites[index]', v-if='filteredSprites[index]')
      .empty-sprite(v-else)
  .row
    .col-12.d-flex.justify-content-center
      div
        b-pagination(size='md', :total-rows='count', v-model='currentPage', :per-page='12')
</template>

<style lang="scss">
  .pagination {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: #a1a39e;

    .page-item span {
      // border: solid 1px rgba(54, 55, 52, 0.24);
    }

    .active .page-link {
      background-color: #f7f8f6;
      color: #a1a39e;
      border: solid 1px rgba(54, 55, 52, 0.24);
    }
  }
</style>

<style lang="scss" scoped>
  .page {
    padding: 2rem;
    padding-left: 15rem;
    padding-right: 15rem;
  }

  @media (max-width: 575.98px) {
    .page {
      padding: 2rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  h1 {
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 2px;
    text-align: center;
    color: #6c6d69;
    margin-bottom: 4rem;
  }

  .filters {
    margin-bottom: 1rem;
    padding-left: 1rem;

    .search {
      width: 282px;
      height: 36px;
      border-radius: 999px;
      border: solid 2px rgba(54, 55, 52, 0.08);
      padding: 1rem;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #a1a39e;
      background: url('../../assets/search.svg') no-repeat scroll 247px 7px;
      background-color: #ffffff;
    }

    .search:focus {
      outline: none;
    }
  }

  .empty-sprite {
    height: 264px;
    border-radius: 8px;
    border: dotted 2px rgba(54, 55, 52, 0.16);
    margin-bottom: 1rem;
  }
</style>

<script>
import axios from 'axios';
import MySpriteItem from './MySpriteItem';
import blockchainSprites from '../../mixins/blockchainSprites';

export default {
  mixins: [blockchainSprites],
  components: {
    MySpriteItem,
  },
  data() {
    return {
      emptySprites: Array(12).fill().map((_, i) => i),
      search: '',
      currentPage: 1,
      count: 12,
    };
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    window.amplitude.getInstance().logEvent('VIEW_MY_SPRITES');
  },
  watch: {
    async currentPage() {
      const page = this.currentPage;
      const response = await axios.get(`/monsters/blockchain-activity?offset=${(page - 1) * 12}`);
      this.$store.state.usersMonsters = response.data.monsters;
      this.count = response.data.count;
    },
  },
  computed: {
    userSprites() {
      if (this.$store.state.usersMonsters.length >= 12 && this.count === 12) this.count = 24;
      return this.$store.state.usersMonsters;
    },
    filteredSprites() {
      if (!this.search) return this.userSprites;

      return this.userSprites.filter(sprite => sprite.name.indexOf(this.search) !== -1);
    },
  },
  methods: {
    viewSprite(sprite) {
      this.$router.push({ name: 'SpritePage', params: { spriteId: sprite._id } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mysprites/MySprites.vue